/* eslint camelcase: 0 */

// Nuestra subclase no hereda los generadores del singleton de blockly/javascript, así
// que hay que declararlos.

const LOGIC_OPERATORS = {
  EQ: '==',
  NEQ: '!=',
  LT: '<',
  LTE: '<=',
  GT: '>',
  GTE: '>=',
};

const LOGIC_OPERATIONS = {
  AND: '&&',
  OR: '||',
};

export const logic_compare = (block, generator) => {
  const operator = LOGIC_OPERATORS[block.getFieldValue('OP')];
  const order = (operator === '==' || operator === '!=')
    ? generator.ORDER_EQUALITY : generator.ORDER_RELATIONAL;
  const a = generator.valueToCode(block, 'A', order) || '0';
  const b = generator.valueToCode(block, 'B', order) || '0';

  return [`${a} ${operator} ${b}`, order];
};

// Si falta un operando se rellena con el neutro (`true` para AND, `false` para OR), como
// Blockly y el set legacy.
export const logic_operation = (block, generator) => {
  const operation = LOGIC_OPERATIONS[block.getFieldValue('OP')];
  const order = (operation === '&&')
    ? generator.ORDER_LOGICAL_AND : generator.ORDER_LOGICAL_OR;
  let a = generator.valueToCode(block, 'A', order);
  let b = generator.valueToCode(block, 'B', order);

  if (!a && !b) {
    a = 'false';
    b = 'false';
  } else {
    const neutro = (operation === '&&') ? 'true' : 'false';
    a = a || neutro;
    b = b || neutro;
  }

  return [`${a} ${operation} ${b}`, order];
};

// Con el hueco vacío emite `!true`, como el generador de Blockly que usaba el legacy.
export const logic_negate = (block, generator) => {
  const order = generator.ORDER_LOGICAL_NOT;
  const bool = generator.valueToCode(block, 'BOOL', order) || 'true';

  return [`!${bool}`, order];
};
